import { trackFullStoryEvent } from 'helpers/fullstory';

import {
  MONITORING_WALKTHROUGH_EVENT,
  type MonitoringWalkthroughCompletionType,
  type MonitoringWalkthroughDismissMethod,
  type MonitoringWalkthroughEntryPoint,
  type MonitoringWalkthroughSection,
} from './monitoring-walkthrough-analytics.constants';

export const trackMonitoringWalkthroughStarted = (
  entryPoint: MonitoringWalkthroughEntryPoint
): void => {
  trackFullStoryEvent(MONITORING_WALKTHROUGH_EVENT.started, {
    section: 'hintTour',
    entryPoint,
  });
};

interface TrackMonitoringWalkthroughViewedArgs {
  section: MonitoringWalkthroughSection;
  stepNumber?: number;
  stepId?: string;
}

export const trackMonitoringWalkthroughViewed = ({
  section,
  stepNumber,
  stepId,
}: TrackMonitoringWalkthroughViewedArgs): void => {
  trackFullStoryEvent(MONITORING_WALKTHROUGH_EVENT.viewed, {
    section,
    ...(stepNumber !== undefined && { stepNumber }),
    ...(stepId && { stepId }),
  });
};

interface TrackMonitoringWalkthroughDismissedArgs {
  section: MonitoringWalkthroughSection;
  dismissMethod: MonitoringWalkthroughDismissMethod;
  stepNumber?: number;
}

export const trackMonitoringWalkthroughDismissed = ({
  section,
  dismissMethod,
  stepNumber,
}: TrackMonitoringWalkthroughDismissedArgs): void => {
  trackFullStoryEvent(MONITORING_WALKTHROUGH_EVENT.dismissed, {
    section,
    dismissMethod,
    ...(stepNumber !== undefined && { stepNumber }),
  });
};

interface TrackMonitoringWalkthroughCompletedArgs {
  section: MonitoringWalkthroughSection;
  completionType: MonitoringWalkthroughCompletionType;
}

export const trackMonitoringWalkthroughCompleted = ({
  section,
  completionType,
}: TrackMonitoringWalkthroughCompletedArgs): void => {
  trackFullStoryEvent(MONITORING_WALKTHROUGH_EVENT.completed, {
    section,
    completionType,
  });
};
